import { type ModalWithStepsStep } from "../../../modal/ModalWithSteps";
import "./confirmLicensingStep.scss";
import LicenseConfirmationInfo from "../../../../features/Licensing/ContentAssignmentModalLicensingSteps/LicenseConfirmationModalContent/licenseConfirmationInfo/LicenseConfirmationInfo";
import { type Context } from "enums/licenseContext";
import { type LicenseConfirmationData } from "../../../../interfaces";
import type { MutableRefObject } from "react";
import type { LicenseConfirmationFormRef } from "../../../../features/Licensing/ContentAssignmentModalLicensingSteps/LicenseConfirmationModalContent/LicenseConfirmationBlockV2/LicenseConfirmationBlock";

export interface ConfirmLicensingStepProps extends ModalWithStepsStep {
  info?: LicenseConfirmationData;
  context?: Context;
  onIsDataValidChange?: (isValid: boolean) => void;
  setIssueLicensePackIds?: (packIds: number[]) => void;
  licenseConfirmationFormRef?: MutableRefObject<LicenseConfirmationFormRef>;
}

const ConfirmLicensingStep: React.FC<ConfirmLicensingStepProps> = (props) => {
  const { info, context, onIsDataValidChange, setIssueLicensePackIds, licenseConfirmationFormRef } = props;
  return (
    <div className="confirm-licensing-step">
      <LicenseConfirmationInfo
        licenseContext={context}
        info={info}
        onIsDataValidChange={onIsDataValidChange}
        setIssueLicensePackIds={setIssueLicensePackIds}
        licenseConfirmationFormRef={licenseConfirmationFormRef}
      />
    </div>
  );
};

export default ConfirmLicensingStep;
